import { useState, useMemo } from 'react';

export default function useDispensaryForm({ onOtherCategoryChange }) {
  const [packSize, setPackSize] = useState(0);
  const [strength, setStrength] = useState('');
  const [schedule, setSchedule] = useState('');
  const [binNumber, setBinNumber] = useState('');
  const [dosageForm, setDosageForm] = useState('');
  const [barcode, setBarcode] = useState('');
  const [drugName, setDrugName] = useState('');
  const [activeIngredient, setActiveIngredient] = useState('');
  const [nappiCode, setNappiCode] = useState('');
  const [reorderLevel, setReorderLevel] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [cost, setCost] = useState('');
  const [manufacturer, setManufacturer] = useState('');
  const [note, setNote] = useState('');
  const [category, setCategory] = useState('');
  const [customCategory, setCustomCategory] = useState('');

  const resetForm = () => {
    setDrugName('');
    setActiveIngredient('');
    setPackSize(0);
    setStrength('');
    setDosageForm('');
    setBarcode('');
    setNappiCode('');
    setSchedule('');
    setBinNumber('');
    setQuantity(0);
    setReorderLevel(0);
    setCost('');
    setManufacturer('');
    setCategory('');
    setCustomCategory('');
    setNote('');
    onOtherCategoryChange?.(false);
  };

  const setCategorySmart = val => {
    setCategory(val);
    if (val !== 'Other') {
      setCustomCategory('');
      onOtherCategoryChange?.(false);
    } else {
      onOtherCategoryChange?.(true);
    }
  };

  const parsedCost = useMemo(() => Number(String(cost).replace(/[^0-9.-]/g, '')) || 0, [cost]);

  return {
    packSize, setPackSize,
    strength, setStrength,
    schedule, setSchedule,
    binNumber, setBinNumber,
    dosageForm, setDosageForm,
    barcode, setBarcode,
    drugName, setDrugName,
    activeIngredient, setActiveIngredient,
    nappiCode, setNappiCode,
    reorderLevel, setReorderLevel,
    quantity, setQuantity,
    cost, setCost, parsedCost,
    manufacturer, setManufacturer,
    note, setNote,
    category, setCategory: setCategorySmart,
    rawCategory: category,
    customCategory, setCustomCategory,
    resetForm,
  };
}
